var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppartement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.705,
    height: 16.616,
    viewBox: "0 0 16.705 16.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1169",
    "data-name": "Groupe 1169",
    transform: "translate(-715.842 -715.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_493",
    "data-name": "Trac\\xE9 493",
    d: "M725.44,719.884c-.076,0-.076-.14-.076-.14v-3.293a.963.963,0,0,0-.881-.957h-7.765a.909.909,0,0,0-.876.957v14.7a.863.863,0,0,0,.876.957h14.947a.868.868,0,0,0,.882-.957V719.814Zm-8.062-1.1c0-.141.145-.21.291-.21h1.91a.228.228,0,0,1,.216.21v1.167a.231.231,0,0,1-.216.222h-1.91c-.146,0-.291-.07-.291-.222Zm0,5.488v-1.168a.331.331,0,0,1,.291-.222h1.91a.341.341,0,0,1,.216.222v1.168a.321.321,0,0,1-.216.292h-1.91a.309.309,0,0,1-.291-.292Zm4.472,6.224a.2.2,0,0,1-.222.222H719.5a.232.232,0,0,1-.222-.222v-3.585a.232.232,0,0,1,.222-.222h2.125a.2.2,0,0,1,.222.222Zm1.9-6.224c0,.152-.076.292-.223.292h-1.9c-.146,0-.216-.14-.216-.292v-1.168a.234.234,0,0,1,.216-.222h1.9a.241.241,0,0,1,.223.222v1.168Zm0-4.32a.2.2,0,0,1-.223.222h-1.9c-.146,0-.216-.07-.216-.222v-1.167c0-.141.07-.21.216-.21h1.9c.146,0,.223.07.223.21v1.167Zm4.175,8.128a.32.32,0,0,1-.216.291H725.8c-.146,0-.216-.14-.216-.291v-1.168c0-.152.07-.222.216-.222h1.909a.231.231,0,0,1,.216.222Zm0-4.321a.232.232,0,0,1-.216.222H725.8c-.146,0-.216-.07-.216-.222v-1.167c0-.152.07-.292.216-.292h1.909a.321.321,0,0,1,.216.292Zm3.445,4.321c0,.152-.07.291-.216.291h-1.909c-.146,0-.216-.14-.216-.291v-1.168c0-.152.07-.222.216-.222h1.909c.146,0,.216.07.216.222Zm0-4.321c0,.152-.07.222-.216.222h-1.909c-.146,0-.216-.07-.216-.222v-1.167c0-.152.07-.292.216-.292h1.909c.146,0,.216.14.216.292Z",
    fill: "#a9aaad",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppartement);
export default __webpack_public_path__ + "static/media/appartement.9e9f8c8ed6b6107af003f8518aa3dfa8.svg";
export { ForwardRef as ReactComponent };